import MediaGalleryOverlay from './MediaGalleryOverlay';

export default MediaGalleryOverlay;
